import { addMethod, number, string } from 'yup';

addMethod(string, 'alphaNumeric', function (props) {
  // props = whether you pass when evoking the method
  // this = the current schema (in this case, string)
  return this.test({
    name: 'alphaNumeric',
    exclusive: true,
    message: '${path} only allow a-z, A-Z, 0-9.',
    test: (value) => /^[a-zA-Z0-9]*$/.test(value),
    ...props,
  });
});

addMethod(number, 'range', function (min, max, props) {
  return this.test({
    name: 'range',
    exclusive: true,
    message: '${path} must be in range ${min} - ${max}.',
    test: (value) => value >= min && value <= max,
    params: { min, max },
    ...props,
  });
});
